import { render, staticRenderFns } from "./quick.vue?vue&type=template&id=44d41350&scoped=true&"
import script from "./quick.vue?vue&type=script&lang=js&"
export * from "./quick.vue?vue&type=script&lang=js&"
import style0 from "./quick.vue?vue&type=style&index=0&id=44d41350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d41350",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuQuickItem: require('/var/web/bet777.es/components/menu/quick_item.vue').default,UiCardWrapper: require('/var/web/bet777.es/themes/dark/ui/Card/Wrapper.vue').default})
